<template>
    <h2 class="workspace-title"
        v-if="game == 'repense'"
        :style="{
            color: colors.primary,
        }"
    >{{title}}</h2>
</template>
<script>
export default {
    created(){
        this.game = localStorage.getItem("game-redirect");
        this.colors = JSON.parse(localStorage.getItem("colors"));
        this.title = localStorage.getItem('workspaceTitle')
    }
}
</script>
<style lang="scss" scoped>
    .workspace-title{
        font-size: 18px;
    }
</style>
